import actions from '../../constants/actions';

export const loadWorks = (refresh = false, slug = null, options = {}) => {
  return {
    type: actions.WORKS.LOAD,
    payload: {
      refresh,
      slug,
      options
    }
  };
};

export const loadWork = id => {
  return {
    type: actions.WORKS.LOAD_SINGLE,
    payload: {
      id
    }
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/works.js